// Central source of truth for the booking URL.
// Update this in one place if the booking provider ever changes.
export const BOOK_URL = "https://calendly.com/rob-thepropertycuratorwarwickshire";
